import React from "react";
import { Building2, MapPin, Landmark, Users } from "lucide-react";

const Row = ({ label, value, testId }) => (
  <div className="flex gap-2 text-xs py-0.5" data-testid={testId}>
    <span className="w-28 shrink-0 text-[#6C757D]">{label}</span>
    <span className="text-[#0B132B] font-medium break-words">{value || "—"}</span>
  </div>
);

const Section = ({ icon: Icon, title, children }) => (
  <div>
    <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.16em] font-bold text-[#6C757D] mb-1"><Icon size={11} /> {title}</div>
    {children}
  </div>
);

export const DealerInfoGrid = ({ d }) => (
  <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4 border-t border-[#F1F3F5] pt-3" data-testid="dealer-info-grid">
    <Section icon={Building2} title="Dealer">
      <Row label="Legal name" value={d.dealer_name} testId="dealer-info-name" />
      <Row label="DBA" value={d.dba} testId="dealer-info-dba" />
      <Row label="EIN" value={d.ein} testId="dealer-info-ein" />
      <Row label="Principal" value={d.dealer_principal ? `${d.dealer_principal}${d.owner_title ? `, ${d.owner_title}` : ""}` : null} testId="dealer-info-principal" />
      <Row label="Physical address" value={d.physical_address} testId="dealer-info-address" />
      <Row label="Mailing address" value={d.mailing_address} testId="dealer-info-mailing" />
      <Row label="Main phone" value={d.phone} testId="dealer-info-phone" />
    </Section>
    <Section icon={Users} title="Contacts">
      <Row label="Primary contact" value={d.contact_name} testId="dealer-info-contact" />
      <Row label="Email" value={d.contact_email} testId="dealer-info-contact-email" />
      <Row label="Phone" value={d.contact_phone} testId="dealer-info-contact-phone" />
      {(d.signers || []).map((s, i) => (
        <Row key={i} label={s.label || "Signer"} value={`${s.name || ""}${s.email ? ` · ${s.email}` : ""}${s.status === "completed" ? " · signed" : ""}`} testId={`dealer-info-signer-${i}`} />
      ))}
    </Section>
    {(d.locations || []).map((l, i) => (
      <Section key={i} icon={MapPin} title={`Location${d.locations.length > 1 ? ` ${i + 1}` : ""}: ${l.name || "—"}`}>
        <Row label="Address" value={l.physical_address} />
        <Row label="Phone" value={l.phone} />
        <Row label="GM" value={l.general_manager} />
        <Row label="F&I director" value={l.fi_director} />
        <Row label="F&I managers" value={(l.fi_managers || []).filter(Boolean).join(", ")} />
        <Row label="Office manager" value={l.office_manager} />
        <Row label="Labor rate" value={l.labor_rate != null && l.labor_rate !== "" ? `$${l.labor_rate}/hr` : null} />
        <Row label="DMS / Menu" value={[l.dms, l.menu_provider].filter(Boolean).join(" / ")} />
      </Section>
    ))}
    {(d.ach_groups || []).length > 0 && (
      <Section icon={Landmark} title="ACH / Banking">
        {d.ach_groups.map((g, i) => (
          <Row key={i} label={g.label || "Account"} value={`${g.bank_name || "—"} · routing ${g.routing_masked} · acct ${g.account_masked}${g.account_holder ? ` · ${g.account_holder}` : ""}`} testId={`dealer-info-ach-${i}`} />
        ))}
      </Section>
    )}
  </div>
);
